module.exports = __webpack_public_path__ + "img/loading-1.61387fab.gif";